import urlParser from './urlParser';

/**
 * this function return a base tag which is base on language path
 *
 * You don't have to add the base tag in every page,
 * just use in the page url which has two or more path after the language, like: `/tw/about/video`.
 * If you are at `/tw/about`, you don't have to add this base tag.
 */
const LanguageBasedTag = () => {
	const baseTag = document.createElement('base');
	baseTag.setAttribute('href', `/${urlParser.language}/`);

	return baseTag;
};

export default LanguageBasedTag;



// WEBPACK FOOTER //
// ./src/js/languageBasedTag.js